import api from './api';
import { Go, GoFormData, ApiResponse } from '../../types/gos.types';

export const gosService = {
  getAll: async (): Promise<ApiResponse<Go[]>> => {
    const response = await api.get<ApiResponse<Go[]>>('/api/gos');
    return response.data;
  },

  getById: async (id: number): Promise<ApiResponse<Go>> => {
    const response = await api.get<ApiResponse<Go>>(`/api/gos/${id}`);
    return response.data;
  },

  create: async (data: GoFormData): Promise<ApiResponse<Go>> => {
    const response = await api.post<ApiResponse<Go>>('/api/gos', data);
    return response.data;
  },

  update: async (id: number, data: GoFormData): Promise<ApiResponse<Go>> => {
    const response = await api.put<ApiResponse<Go>>(`/api/gos/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/api/gos/${id}`);
    return response.data;
  },

  uploadPdf: async (file: File): Promise<ApiResponse<{ url: string; filename: string }>> => {
    const fd = new FormData();
    fd.append('document', file);
    const response = await api.post<ApiResponse<{ url: string; filename: string }>>('/api/gos/upload-pdf', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};
